((document, window, history) => {
	const pushState = history.pushState;

	function olivierImagetoggle(){
			var pages = document.querySelectorAll('.gform_page');
			pages.forEach(function(page) {
				var radioButtons = page.querySelectorAll('input[type="radio"]');
				var imageContainer = page.querySelector('.image-container');
		
				function toggleImages() {
					var oneImage = imageContainer.querySelector('.one-image');
					var threeImage = imageContainer.querySelector('.three-image');
					var fiveImage = imageContainer.querySelector('.five-image');
		
					if (this.value === '1' || this.value === '2') {
						oneImage.style.display = 'block';
						threeImage.style.display = 'none';
						fiveImage.style.display = 'none';
					} else if (this.value === '3') {
						oneImage.style.display = 'none';
						threeImage.style.display = 'none';
						fiveImage.style.display = 'none';
					} else if (this.value === '4' || this.value === '5') {
						oneImage.style.display = 'none';
						threeImage.style.display = 'none';
						fiveImage.style.display = 'block';
					}
				}
		
				radioButtons.forEach(function(radioButton) {
					radioButton.addEventListener('click', toggleImages);
				});
			});
		
		

		
	}


	// default cookie compliance script
	function cookieCompliance() {
		if (document.querySelector('.farlo-ui-biscuit-banner__button')) {
			document.querySelector('.farlo-ui-biscuit-banner__button').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');

				window._farlo.storage.set('cookieCompliance', 'true', 'cookie');
			});
		}

		if (document.querySelector('.farlo-ui-biscuit-banner__button--close')) {
			document.querySelector('.farlo-ui-biscuit-banner__button--close').addEventListener('click', (e) => {
				e.preventDefault();

				e.target.closest('.farlo-ui-biscuit-banner').classList.add('farlo-ui-biscuit-banner--hide');
			});
		}
	}

	if (document.querySelector('.wp-block-embed')) {
		document.querySelectorAll('.wp-block-embed__wrapper').forEach(function(_sel) {
		  const embedDiv = document.createElement('div');

		  if (!(_sel.querySelector('.wp-block-embed__player'))) {
				embedDiv.className = 'wp-block-embed__player';
				_sel.append(embedDiv);

				embedDiv.addEventListener('click', (e) => {
			  const iframe = e.currentTarget.parentNode.querySelector('iframe');
			  const dataSrc = iframe.getAttribute('data-src');

			  e.currentTarget.parentNode.classList.toggle('wp-block-embed__wrapper--is-playing');

			  if (dataSrc) {
						iframe.setAttribute('src', dataSrc + '&autoplay=1&playsinline=1&muted=1');
			  } else {
						const src = iframe.getAttribute('src');
						iframe.setAttribute('src', src + '&autoplay=1&playsinline=1&muted=1');
			  }
				});
		  }
		});
	  }

	// default navicon
	function navicon() {
		document.querySelector('.site-navigation__navicon').addEventListener('click', (e) => {
			e.preventDefault();
			e.currentTarget.classList.toggle('site-navigation__navicon--active');
			document.querySelector('.site-navigation').classList.toggle('site-navigation__nav--active');
			document.body.classList.toggle('site-navigation__nav--open');
		});
	}

	// lazyloading
	function lazyloadElements() {
		const observer = new IntersectionObserver(function(entries, obs) {
			entries.forEach(function(entry) {
				// If the entry is not in the viewport, do nothing
				if (!entry.isIntersecting) {
					return;
				}

				// Stop observing
				obs.unobserve(entry.target);

				// Add class
				entry.target.classList.add('in-view');
			});
		});

		// The element to observe
		const elements = (document.querySelector('.site-page').querySelector('section, div').children);

		for (let i = 0; i < elements.length; i += 1) {
			// Attach it to the observer
			observer.observe(elements[ i ]);
		}
	}

	function postAjax() {
		// Get all elements with class 'cat-list_item' and attach a click event listener to each
		const catItems = document.querySelectorAll('.cat-list_item');
		catItems.forEach(function(catItem, index) {
			catItem.addEventListener('click', function(event) {
				event.preventDefault();

				// If this item is already active, find the next one that is not active
				if (catItem.classList.contains('active')) {
					// Find the next 'cat-list_item' element that is not 'active'
					for (let i = 0; i < catItems.length; i ++) {
						if (i !== index && !catItems[ i ].classList.contains('active')) {
							// Add 'active' class to the next element
							catItems[ i ].classList.add('active');

							// Remove 'active' class from the current element
							catItem.classList.remove('active');

							break;
						}
					}
				} else {
					// Remove 'active' class from all elements with class 'cat-list_item'
					catItems.forEach(function(item) {
						item.classList.remove('active');
					});

					// Add 'active' class to the clicked element
					catItem.classList.add('active');
				}

				// Get the unique block ID for this block instance
				const blockId = this.closest('.posts').getAttribute('data-block-id');
				const cardStyle = this.closest('.posts').getAttribute('data-card-style'); // Fetch the card_style
				const postsPerPage = this.closest('.posts').getAttribute('data-loading-posts-per-page');
				const postType = this.closest('.posts').getAttribute('data-post-type');

				// Create a new XMLHttpRequest object
				const xhr = new XMLHttpRequest();

				// Configure the request
				xhr.open('POST', '/wp-admin/admin-ajax.php', true);
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

				// Define the data to be sent in the request
				const data = 'action=filter_projects&order=' + this.getAttribute('data-slug') + '&block_id=' + blockId + '&card_style=' + cardStyle + '&posts_per_page=' + postsPerPage + '&post_type=' + postType;

				// Set up the 'load' event listener to handle the response
				xhr.addEventListener('load', function() {
					if (xhr.status === 200) {
						// Update the content of the specific block instance with the response
						setTimeout(function() {
							document.querySelector('[data-block-id="' + blockId + '"] .post-grid').innerHTML = xhr.responseText;
							// After updating the content with AJAX response
							const newPosts = document.querySelectorAll('[data-block-id="' + blockId + '"] .post-grid__item:not(.new)');
							setTimeout(function() {
								newPosts.forEach(function(post) {
									post.classList.add('new');
								});
							}, 500);
						}, 1000);

						// After updating the content with AJAX response
						const oldPosts = document.querySelectorAll('[data-block-id="' + blockId + '"] .post-grid__item:not(.old)');

						// Delay before fading out old posts
						oldPosts.forEach(function(post) {
							post.classList.remove('new');
							post.classList.add('old');
						});
					}
				});

				// Send the request
				xhr.send(data);
			});
		});
	}

	function ajaxLoadMore() {
		let currentPage = 2;
		const loadMoreButton = document.getElementById('load-more');
		const postBlock = loadMoreButton.closest('.posts');

		if (loadMoreButton) {
			loadMoreButton.addEventListener('click', function(event) {
				event.preventDefault();

				// Get the unique block ID and card style
				const blockId = this.closest('.posts').getAttribute('data-block-id');
				const cardStyle = this.closest('.posts').getAttribute('data-card-style');
				const postsPerPage = this.closest('.posts').getAttribute('data-posts-per-page');
				const postType = this.closest('.posts').getAttribute('data-post-type');
				const dataPostsPerPage = this.closest('.posts').getAttribute('data-loading-posts-per-page');

				// Get the current order (ASC or DESC)
				const currentOrder = document.querySelector('.cat-list_item.active').getAttribute('data-slug');
				// Create a new XMLHttpRequest object
				const xhr = new XMLHttpRequest();

				// Configure the request
				xhr.open('POST', '/wp-admin/admin-ajax.php', true);
				xhr.setRequestHeader('Content-Type', 'application/x-www-form-urlencoded');

				// Define the data to be sent in the request
				const data = new URLSearchParams();
				data.append('action', 'load_more_posts');
				data.append('current_page', currentPage);
				data.append('block_id', blockId);
				data.append('card_style', cardStyle);
				data.append('posts_per_page', postsPerPage);
				data.append('post_type', postType);
				data.append('order', currentOrder); // Pass the current order to the server

				// Set up the 'load' event listener to handle the response
				xhr.addEventListener('load', function() {
					if (xhr.status === 200) {
						const res = xhr.responseText;
						const publicationList = document.querySelector('[data-block-id="' + blockId + '"] .post-grid');
						if (res === 'empty') {
							loadMoreButton.style.display = 'none'; // Hide the "Load more" button
						} else {
							publicationList.insertAdjacentHTML('beforeend', res);

							// After updating the content with AJAX response
							const newPosts = document.querySelectorAll('[data-block-id="' + blockId + '"] .post-grid__item:not(.new)');
							setTimeout(function() {
								newPosts.forEach(function(post) {
									post.classList.add('new');
								});
							}, 500);

							// After updating the content with AJAX response
							const oldPosts = document.querySelectorAll('[data-block-id="' + blockId + '"] .post-grid__item:not(.old)');
						}
						const newDataPostsPerPage = parseInt(postsPerPage) + parseInt(dataPostsPerPage);
						postBlock.setAttribute('data-loading-posts-per-page', newDataPostsPerPage); // Use single quotes around the attribute name
					}
				});

				// Send the request
				xhr.send(data);

				currentPage ++; // Increment currentPage for the next load
			});
		}
	}

	const checkInputValue = (_inp) => {
		if (_inp.value) {
			_inp.parentElement.classList.add('form-item-active');
		} else {
			_inp.parentElement.classList.remove('form-item-active');
		}
	};
	document.querySelectorAll('.gfield input').forEach((_inp) => {
		const parentDiv = _inp.closest('.gfield');

		_inp.addEventListener('focus', () => {
		  parentDiv.classList.add('gfield--active');
		});

		_inp.addEventListener('blur', () => {
		  parentDiv.classList.remove('gfield--active');
		  checkInputValue(_inp);
		});

		checkInputValue(_inp);
	  });

	document.querySelectorAll('.gfield textarea').forEach((_inp) => {
		const parentDiv = _inp.closest('.gfield');

		_inp.addEventListener('focus', () => {
		  parentDiv.classList.add('gfield--active');
		});

		_inp.addEventListener('blur', () => {
		  parentDiv.classList.remove('gfield--active');
		  checkInputValue(_inp);
		});

		checkInputValue(_inp);
	  });

	  function autoExpandTextarea(textarea) {
		// Reset the textarea's height to its default value to ensure that
		// we're measuring the scrollHeight accurately for the current content.
		textarea.style.height = 'auto';
		textarea.style.height = textarea.scrollHeight + 'px';

			  // Add an event listener to the textarea to call the function when the user types.
			  const textareaElement = document.querySelector('.textarea'); // Replace with your actual textarea ID
			  textareaElement.addEventListener('input', function() {
			autoExpandTextarea(textareaElement);
			  });
	  }

	function mobileCarousel() {
		document.querySelectorAll('[farlo-ui="mobile-carousel"]').forEach(function(_sel) {
			const config = {
				cellAlign: 'center',
				wrapAround: false,
				draggable: true,
				pageDots: true,
				prevNextButtons: false,
				autoPlay: false,
				watchCSS: true
			};
			const carousel = new Flickity(_sel, config);
		});
	}

	function careersListing() {
		const careers = document.querySelector('.site-careers');
		const tabButtons = careers.querySelectorAll('.site-careers__tabs-buttons-button');
		const tabLocationButtons = careers.querySelectorAll('.site-careers__secondary-tabs-list-item');
		const listing = careers.querySelector('.site-careers__tabs-listing');

		function fetchCareers(e) {
			if (e.target.classList.contains('site-careers__tabs-buttons-button--active') || e.target.classList.contains('site-careers__secondary-tabs-list-item--active')) {
				return;
			}

			for (let i = 0; i < tabButtons.length; i += 1) {
				tabButtons[ i ].classList.remove(`${ e.target.classList[ 0 ] }--active`);
			}

			for (let i = 0; i < tabLocationButtons.length; i += 1) {
				tabLocationButtons[ i ].classList.remove(`${ e.target.classList[ 0 ] }--active`);
			}

			e.target.classList.add(`${ e.target.classList[ 0 ] }--active`);

			const activeCompany = careers.querySelector('.site-careers__tabs-buttons-button--active');
			const activeLocation = careers.querySelector('.site-careers__secondary-tabs-list-item--active');

			const data = new URLSearchParams({
				action: 'farloCareersFilter',
				tag: activeCompany ? activeCompany.getAttribute('data-toggle-id') : e.target.dataset.toggleId,
				filterBy: activeCompany ? activeCompany.getAttribute('data-filter-by') : e.target.dataset.filterBy,
				category: activeLocation ? activeLocation.getAttribute('data-toggle-location') : e.target.dataset.toggleLocation,
				nonce: farloAjaxHandler.nonce
			});

			listing.classList.add('site-careers__tabs-listing--loading');

			fetch(farloAjaxHandler.ajaxurl, {
				method: 'POST',
				body: data,
				headers: {
					'Accept': 'application/json',
					'Content-type': 'application/x-www-form-urlencoded',
					'X-WP-Nonce': farloAjaxHandler.nonce
				}
			}).then((response) => response.text()).then((res) => {
				if (res !== '') {
					listing.innerHTML = res;
					listing.classList.remove('site-careers__tabs-listing--loading');
				}
			}).catch((error) => {
				listing.innerHTML = `Error: ${ error }`;
				console.error('There was an error!', error);
			});
		}

		for (let i = 0; i < tabButtons.length; i += 1) {
			tabButtons[ i ].addEventListener('click', fetchCareers);
		}

		for (let j = 0; j < tabLocationButtons.length; j += 1) {
			tabLocationButtons[ j ].addEventListener('click', fetchCareers);
		}
	}

	function locationsTabs() {
		const tabItems = document.querySelectorAll('.locations__tabs-item');
		const addressItems = document.querySelectorAll('.locations__addresses-item');

		tabItems.forEach(function(tab) {
			tab.addEventListener('click', function(event) {
				event.preventDefault();
				const locationTitle = tab.getAttribute('data-location');

				// Remove 'locations__tabs-item--active' class from all tabs
				tabItems.forEach(function(item) {
					item.classList.remove('locations__tabs-item--active');
				});

				// Remove 'locations__addresses-item--active' class from all address items
				addressItems.forEach(function(item) {
					item.classList.remove('locations__addresses-item--active');
				});

				// Add 'locations__tabs-item--active' class to the clicked tab
				tab.classList.add('locations__tabs-item--active');

				// Add 'locations__addresses-item--active' class to the corresponding address item
				const matchingAddressItem = document.querySelector('.locations__addresses-item[data-location="' + locationTitle + '"]');
				if (matchingAddressItem) {
					matchingAddressItem.classList.add('locations__addresses-item--active');
				}
			});
		});
	}

	function numberCounter() {
		// Select all instances of the number block
		const numberBlocks = document.querySelectorAll('.number-block');

		// Function to start counting up for a single block
		function startCounting(element) {
			const numberSpan = element.querySelector('.number');
			let startValue = parseInt(numberSpan.getAttribute('data-start-number')) || 0;
			const originalValue = parseFloat(numberSpan.innerText);
			const intervalSpeed = parseInt(numberSpan.getAttribute('data-interval-speed')) || 1; // Default to 200 if not specified

			// Check if the original value has two decimal places
			const hasTwoDecimalPlaces = (originalValue % 1 !== 0);

			// Function to format the displayed number with two decimal places if needed
			function formatNumber(value) {
				return hasTwoDecimalPlaces ? value.toFixed(2) : value.toFixed(0);
			}

			// Interval to update the count
			const interval = setInterval(function() {
				if (startValue <= originalValue) {
					numberSpan.textContent = formatNumber(startValue);
					startValue += hasTwoDecimalPlaces ? 0.01 : 1;
				} else {
					clearInterval(interval);
				}
			}, intervalSpeed); // Use intervalSpeed for the interval
		}

		// Intersection Observer callback
		function handleIntersection(entries, observer) {
			entries.forEach((entry) => {
				if (entry.isIntersecting) {
					startCounting(entry.target);
					observer.unobserve(entry.target);
				}
			});
		}

		// Create an Intersection Observer for each number block
		numberBlocks.forEach((block) => {
			const observer = new IntersectionObserver(handleIntersection, {
				root: null,
				rootMargin: '0px',
				threshold: 0.2 // Adjust the threshold as needed
			});
			observer.observe(block);
		});
	}

	function carousels() {
		document.querySelectorAll('.wp-block-gallery.columns-1').forEach(function(_sel) {
			const config = {
				cellAlign: 'center',
				wrapAround: false,
				draggable: true,
				pageDots: true,
				prevNextButtons: false,
				autoPlay: false
			};
			if (_sel.children.length > 1) {
				const carousel = new Flickity(_sel, config);
			}
		});
	}

	document.addEventListener('DOMContentLoaded', function() {
		const teamBlockGrid = document.querySelector('.team-block__grid');
		const hideButton = document.querySelector('.team-block__hide-button');
		const hideSection = document.querySelector('.team-block__hide');

		if (hideButton && teamBlockGrid && hideSection) {
			hideButton.addEventListener('click', function() {
				teamBlockGrid.style.transition = 'max-height 0.5s'; // Adjust the duration as needed
				teamBlockGrid.style.maxHeight = teamBlockGrid.scrollHeight + 'px';

				// Hide the 'team-block__hide' element
				hideSection.style.display = 'none';
			});
		}
	});

	function sineWaves() {
		const canvas = document.querySelector('.sine-waves__canvas');
		const ctx = canvas.getContext('2d');

		const waves = [
			{ x: 100, y: 500, direction: 1, speed: 0.05, amplitude: 200, wavelength: 250 },
			{ x: -100, y: 550, direction: 1, speed: 0.1, amplitude: 150, wavelength: 200 },
			{ x: -200, y: 450, direction: -1, speed: 0.15, amplitude: 100, wavelength: 200 },
			{ x: 250, y: 450, direction: -1, speed: 0.2, amplitude: 100, wavelength: 200 }
		];

		const colors = [
			'rgba(255, 248, 241, 0.4)',
			'rgba(240, 225, 212, 0.39)',
			'rgba(255, 248, 241, 0.4)',
			'rgba(207, 164, 126, 0.15)'
		];

		function animate() {
			ctx.clearRect(0, 0, canvas.width, canvas.height);
			waves.forEach((wave, index) => {
				ctx.fillStyle = colors[ index ];
				ctx.beginPath();
				ctx.moveTo(0, canvas.height);
				ctx.lineTo(0, wave.y);
				for (let i = 0; i < canvas.width; i += 1) {
					const x = i;
					const y = wave.y + Math.sin(x / wave.wavelength + wave.x) * wave.amplitude;
					ctx.bezierCurveTo(x - 30, y, x, y - 30, x + 20, y);
				}
				ctx.lineTo(canvas.width, canvas.height);
				ctx.closePath();
				ctx.fill();
				wave.x += wave.direction / (wave.wavelength);
			});

			requestAnimationFrame(animate);
		}

		canvas.width = window.innerWidth;
		canvas.height = window.innerHeight;
		animate();

		window.addEventListener('resize', () => {
			canvas.width = window.innerWidth;
			canvas.height = window.innerHeight;
		});
	}

	function socialShare() {
		const shareButton = document.querySelector('.farlo-ui-social-share__button');

		shareButton.addEventListener('click', (e) => {
			e.currentTarget.parentNode.classList.toggle('farlo-ui-social-share--active');
		});

		window.addEventListener('scroll', () => {
			if (shareButton.getBoundingClientRect().bottom >= document.querySelector('.site-footer').getBoundingClientRect().top) {
				shareButton.parentNode.classList.add('farlo-ui-social-share--bottom');
				shareButton.parentNode.style.bottom = document.querySelector('.site-footer').clientHeight + shareButton.clientHeight + 'px';
			} else {
				shareButton.parentNode.classList.remove('farlo-ui-social-share--bottom');
				shareButton.parentNode.removeAttribute('style');
			}
		});
	}

	function fifthWallDots() {
		class InteractiveParticles {
			constructor(canvas, args) {
				const that = this;
				this.canvas = canvas;
				this.args = args;
				this.density = 0;
				this.produceDistance = 1000;
				this.baseRadius = 1000;
				this.reactionSensitivity = 15;
				this.particleRecessSpeed = 0.05;
				this.canvasPadding = 0;
				this.ignoreColors = [];
				this.particles = [];
				this.mouse = {
					x: -1000,
					y: -1000,
					down: false
				};

				this.animation = null;
				this.context = null;
				this.bgImage = null;
				this.bgCanvas = null;
				this.bgContext = null;
				this.bgContextPixelData = null;

				for (const key in args) {
					this[ key ] = args[ key ];
				}

				this.add = function() {
					// Set up the visual canvas
					that.context = that.canvas.getContext('2d', { alpha: true });

					// this.context.globalCompositeOperation = "lighter";
					if (that.size.length) {
						that.canvas.width = (that.size[ 0 ] + that.canvasPadding) * 2;
						that.canvas.height = (that.size[ 1 ] + that.canvasPadding) * 2;
					} else {
						that.canvas.width = (that.canvas.clientWidth + that.canvasPadding) * 2;
						that.canvas.height = that.canvas.clientHeight + that.canvasPadding * 2;
					}

					that.canvas.style.display = 'block';
					that.canvas.addEventListener('mousemove', that.pointerMove, false);
					that.canvas.addEventListener('mouseout', that.pointerOut, false);
					that.canvas.addEventListener('touchstart', that.pointerMove, false);
					that.canvas.addEventListener('ontouchend', that.pointerOut, false);

					window.onresize = function() {
						if (that.size.length) {
							that.canvas.width = that.size[ 0 ];
							that.canvas.height = that.size[ 1 ];
						} else {
							that.canvas.width = that.canvas.clientWidth;
							that.canvas.height = that.canvas.clientHeight;
						}
						that.onWindowResize();
					};

					// Load initial input image
					that.getImageData(that.image);
				};

				this.makeParticles = function() {
					// remove the current particles
					that.particles = [];
					let i, j;
					const colors = that.bgContextPixelData.data;

					for (i = 0; i < that.canvas.height; i += that.density) {
						for (j = 0; j < that.canvas.width; j += that.density) {
							const pixelPosition = (j + i * that.bgContextPixelData.width) * 4;

							// Ignore colors
							let ignoreColor = false;
							if (that.ignoreColors.length) {
								for (const ckey in that.ignoreColors) {
									if (colors[ pixelPosition ] === that.ignoreColors[ ckey ][ 0 ] && colors[ pixelPosition + 1 ] === that.ignoreColors[ ckey ][ 1 ] && colors[ pixelPosition + 2 ] === that.ignoreColors[ ckey ][ 2 ]) {
										ignoreColor = true;
									}
								}
								if (ignoreColor) {
									continue;
								}
							}

							const color = 'rgba(' + colors[ pixelPosition ] + ',' + colors[ pixelPosition + 1 ] + ',' + colors[ pixelPosition + 2 ] + ',' + '1)';
							that.particles.push({
								x: j,
								y: i,
								originalX: j,
								originalY: i,
								color,
								radius: 1 + Math.ceil(Math.random() * 5)
							});
						}
					}
				};

				this.updateparticles = function() {
					let i, currentPoint, theta, distance;

					for (i = 0; i < that.particles.length; i ++) {
						currentPoint = that.particles[ i ];

						theta = Math.atan2(currentPoint.y - that.mouse.y, currentPoint.x - that.mouse.x);

						if (that.mouse.down) {
							distance = that.reactionSensitivity * 200 / Math.sqrt((that.mouse.x - currentPoint.x) * (that.mouse.x - currentPoint.x) +
								(that.mouse.y - currentPoint.y) * (that.mouse.y - currentPoint.y));
						} else {
							distance = that.reactionSensitivity * 100 / Math.sqrt((that.mouse.x - currentPoint.x) * (that.mouse.x - currentPoint.x) +
								(that.mouse.y - currentPoint.y) * (that.mouse.y - currentPoint.y));
						}

						currentPoint.x += Math.cos(theta) * distance + (currentPoint.originalX - currentPoint.x) * that.particleRecessSpeed;
						currentPoint.y += Math.sin(theta) * distance + (currentPoint.originalY - currentPoint.y) * that.particleRecessSpeed;
					}
				};

				this.produceparticles = function() {
					let i, currentPoint;

					for (i = 0; i < that.particles.length; i ++) {
						currentPoint = that.particles[ i ];

						// produce the dot.
						that.context.fillStyle = currentPoint.color;
						that.context.strokeStyle = currentPoint.color;

						that.context.beginPath();
						that.context.arc(currentPoint.x, currentPoint.y, currentPoint.radius, 0, Math.PI * 2, true);
						that.context.closePath();
						that.context.fill();
					}
				};

				this.produce = function() {
					that.animation = requestAnimationFrame(function() {
						that.produce();
					});

					that.remove();
					that.updateparticles();
					that.produceparticles();
				};

				this.remove = function() {
					that.canvas.width = that.canvas.width;
				};

				// The filereader has loaded the image... add it to image object to be producen
				this.getImageData = function(data) {
					that.bgImage = new Image();
					that.bgImage.src = data;

					that.bgImage.onload = function() {
						that.produceInteractiveParticles();
					};
				};

				// Image is loaded... produce to bg canvas
				this.produceInteractiveParticles = function() {
					that.bgCanvas = document.createElement('canvas');
					that.bgCanvas.width = that.canvas.width;
					that.bgCanvas.height = that.canvas.height;

					const newWidth = that.bgImage.width;
					const newHeight = that.bgImage.height;

					// produce to background canvas
					that.bgContext = that.bgCanvas.getContext('2d', { alpha: false });
					that.bgContext.drawImage(that.bgImage, Math.round((that.canvas.width - newWidth) / 2), Math.round((that.canvas.height - newHeight) / 2), Math.round(newWidth), Math.round(newHeight));
					that.bgContextPixelData = that.bgContext.getImageData(0, 0, Math.round(that.bgCanvas.width), Math.round(that.bgCanvas.height));

					that.makeParticles();
					that.produce();
				};

				this.pointerMove = function(event) {
					that.mouse.x = event.offsetX || event.layerX - that.canvas.offsetLeft;
					that.mouse.y = event.offsetY || event.layerY - that.canvas.offsetTop;
				};

				this.pointerOut = function(event) {
					that.mouse.x = -1000;
					that.mouse.y = -1000;
					that.mouse.down = false;
				};

				// Resize and reproduce the canvas.
				this.onWindowResize = function() {
					cancelAnimationFrame(that.animation);
					that.produceInteractiveParticles();
				};

				this.add(this.canvas, this.args);
			}
		}
		const dots = new InteractiveParticles(document.getElementById('fifth-wall-dots'), {
			size: [1729, 1118],
			density: 60,
			baseRadius: 2,
			ignoreColors: [
				[0, 0, 0]
			],
			image: 'data:image/png;base64,' + dotsUrl
		});
	}

	function fifthwallForm() {
		document.querySelector('.nojs-trigger a').addEventListener('click', (e) => {
			e.preventDefault();
			document.querySelector('.nojs-checkbox').checked = true;
		});
	}

	function lightMenuToggle() {
		const black = document.querySelectorAll('.masthead');

		for (let i = 0; i < black.length; i ++) {
			black[ i ].classList.add('color-menu');
		}

		window.addEventListener('scroll', function() {
			let inColorMenu = false;
			const top_of_screen = window.pageYOffset || document.documentElement.scrollTop;

			const colorMenus = document.querySelectorAll('.color-menu');
			for (let i = 0; i < colorMenus.length; i ++) {
				const top_of_element = colorMenus[ i ].offsetTop;
				const bottom_of_element = top_of_element + colorMenus[ i ].offsetHeight;

				if (top_of_screen > top_of_element && top_of_screen < bottom_of_element) {
					inColorMenu = true;
					break;
				}
			}

			const header = document.querySelector('.site-header');
			if (inColorMenu || top_of_screen === 0) {
				header.classList.add('dark-menu');
			} else {
				header.classList.remove('dark-menu');
			}
		});
	}

	if (document.querySelector('.masthead')) {
		lightMenuToggle();
	}

	function teamSlider() {
		// Get all the team block containers
		const teamBlocks = document.querySelectorAll('.team-block__grid');

		teamBlocks.forEach((teamBlock) => {
			let isDragging = false;
			let startPosition = 0;
			let scrollLeft = 0;
			const sensitivityFactor = 2; // Adjust the factor as needed

			teamBlock.addEventListener('mousedown', (e) => {
				if (e.target.tagName === 'IMG') {
					e.preventDefault(); // Prevent default image drag behavior
				}

				isDragging = true;
				startPosition = e.clientX;
				scrollLeft = teamBlock.scrollLeft;
				teamBlock.style.scrollSnapType = 'none';
				teamBlock.style.cursor = 'grabbing';
			});

			teamBlock.addEventListener('mouseup', () => {
				isDragging = false;
				teamBlock.style.scrollSnapType = 'x mandatory';
			});

			teamBlock.addEventListener('mouseleave', () => {
				isDragging = false;
				teamBlock.style.scrollSnapType = 'x mandatory';
			});

			teamBlock.addEventListener('mousemove', (e) => {
				if (!isDragging) {
					return;
				}

				const deltaX = (e.clientX - startPosition) * sensitivityFactor; // Adjust sensitivity here
				teamBlock.scrollLeft = scrollLeft - deltaX;
			});
		});
	}
	function accreditationSlider() {
		const accreditationsList = document.querySelector('.accreditations__list');
		const pageDotsContainer = document.querySelector('.accreditations__page-dots');

		// Add the items and corresponding page dots
		const items = accreditationsList.querySelectorAll('.accreditations__list-item');
		const pageDots = [];

		items.forEach((item, index) => {
		  const dot = document.createElement('div');
		  dot.classList.add('page-dot');
		  pageDotsContainer.appendChild(dot);
		  pageDots.push(dot);

		  // Add click event to jump to the corresponding item
		  dot.addEventListener('click', () => {
				scrollToItem(index);
		  });
		});

		// Initialize variables for automatic scrolling
		let currentItemIndex = 0;
		let isAutoScrolling = false;

		// Function to scroll to a specific item
		function scrollToItem(index) {
		  accreditationsList.scrollTo({
				left: items[ index ].offsetLeft,
				behavior: 'smooth'
		  });

		  currentItemIndex = index;

		  // Update page dots
		  updatePageDots();
		}

		// Function to update page dots based on the current item
		function updatePageDots() {
		  pageDots.forEach((dot, index) => {
				if (index === currentItemIndex) {
			  dot.classList.add('active');
				} else {
			  dot.classList.remove('active');
				}
		  });
		}

		// Function for automatic scrolling
		function autoScroll() {
		  if (!isAutoScrolling) {
				return;
		  }

		  currentItemIndex ++;
		  if (currentItemIndex >= items.length) {
				currentItemIndex = 0;
		  }

		  scrollToItem(currentItemIndex);

		  setTimeout(autoScroll, 3000); // Adjust the time interval (in milliseconds) as needed
		}

		// Start automatic scrolling
		isAutoScrolling = true;
		autoScroll();

		let isDragging = false;
		let startPosition = 0;
		let scrollLeft = 0;
		const sensitivityFactor = 2; // Adjust the factor as needed

		accreditationsList.addEventListener('mousedown', (e) => {
			if (e.target.tagName === 'IMG') {
				e.preventDefault(); // Prevent default image drag behavior
			}
		  isDragging = true;
		  startPosition = e.clientX;
		  scrollLeft = accreditationsList.scrollLeft;
		  accreditationsList.style.scrollSnapType = 'none';
		});

		accreditationsList.addEventListener('mouseup', () => {
		  isDragging = false;
		  accreditationsList.style.scrollSnapType = 'x mandatory';
		});

		accreditationsList.addEventListener('mouseleave', () => {
		  isDragging = false;
		  accreditationsList.style.scrollSnapType = 'x mandatory';
		});

		accreditationsList.addEventListener('mousemove', (e) => {
		  if (!isDragging) {
				return;
			}

		  const deltaX = (e.clientX - startPosition) * sensitivityFactor; // Adjust sensitivity here
		  accreditationsList.scrollLeft = scrollLeft - deltaX;
		});
	}

	function openMobileShare() {
		const shareButton = document.querySelector('.social-share-button');
		const lightbox = document.querySelector('.share-lightbox');
		const lightboxInner = document.querySelector('.share-lightbox__inner');
	  
		if (!shareButton || !lightbox || !lightboxInner) {
		  console.error("Required elements not found.");
		  return;
		}
	  
		shareButton.addEventListener('click', function(event) {
		  event.preventDefault(); // Prevent the default link behavior
	  
		  if (navigator.share) {
			// Use the Web Share API to open the share dialog
			navigator.share({
			  title: document.title,
			  url: window.location.href
			}).then(() => {
			  //console.log('Thanks for sharing!');
			}).catch((error) => {
			  console.error('Error sharing:', error);
			});
		  } else {
			// Activate the lightbox and add 'lightbox' class to the body
			lightbox.classList.add('share-lightbox--active');
			document.body.classList.add('lightbox');
		  }
		});
	  
		// Close the lightbox when clicking outside the inner content
		lightbox.addEventListener('click', function(event) {
		  if (event.target === this) { // This checks if the click was not on a child element
			lightbox.classList.remove('share-lightbox--active');
			document.body.classList.remove('lightbox');
		  }
		});
	  }
	  

	  function notifyForm() {
		// Get references to all buttons and the form
		const buttons = document.querySelectorAll('.wp-element-button'); // Select all buttons
		const form = document.querySelector('.notify-me');

		// Get the maximum height of the form
		const maxHeight = form.scrollHeight + 'px';

		// Set the form's initial height and transition properties
		form.style.height = '0';
		form.style.overflow = 'hidden';
		form.style.transition = 'height 0.5s';

		let isFormOpen = false;
		let startHeight, endHeight;

		// Function to toggle form visibility with smooth transition
		function toggleForm() {
			if (isFormOpen) {
				startHeight = form.offsetHeight;
				endHeight = 0;
				isFormOpen = false;
			} else {
				startHeight = 0;
				endHeight = parseInt(maxHeight);
				isFormOpen = true;
			}

			let animationStartTime = null;

			function animate(currentTime) {
				if (!animationStartTime) {
					animationStartTime = currentTime;
				}
				const progress = (currentTime - animationStartTime) / 500; // 500ms duration

				if (progress < 1) {
					const newHeight = startHeight + (endHeight - startHeight) * progress;
					form.style.height = newHeight + 'px';
					requestAnimationFrame(animate);
				} else {
					form.style.height = endHeight + 'px';
					animationStartTime = null;
				}
			}

			requestAnimationFrame(animate);
		}

		// Add click event listeners to all buttons to toggle the form
		buttons.forEach(function(button) {
			button.addEventListener('click', toggleForm);
		});
	}

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		if (document.querySelector('.site-navigation__navicon')) {
			navicon();
		}

		if (document.querySelector('.farlo-ui-biscuit-banner')) {
			cookieCompliance();
		}

		if (document.querySelector('.site-page')) {
			lazyloadElements();
		}

		if (document.querySelector('.notify-me')) {
			notifyForm();
		}

		if (document.querySelector('.site-careers')) {
			careersListing();
		}

		if (document.querySelector('.team-block')) {
			//teamSlider();
		}

		if (document.querySelector('.accreditations__list')) {
			 accreditationSlider();
		}

		if (document.querySelector('.enable-ajax')) {
			postAjax();
			ajaxLoadMore();
		}

		if (document.querySelector('.social-share-button')){
			openMobileShare(); 
		}

		if (document.querySelector('.wp-block-embed')) {
			document.querySelectorAll('video').forEach(function(_sel) {
				_sel.addEventListener('playing', (e) => {
					e.target.parentNode.classList.add('wp-block-video--is-playing');
				});

				_sel.onpause = function() {
					_sel.parentNode.classList.remove('wp-block-video--is-playing');
				};
			});
		}

		if (document.querySelector('.sine-waves')) {
			sineWaves(document.querySelector('.sine-waves'));
		}

		if (document.querySelector('.number-block')) {
			numberCounter();
		}

		if (document.querySelector('ginput_container_textarea')) {
			autoExpandTextarea(textareaElement);
		}

		if (document.querySelector('.farlo-ui-social-share')) {
			socialShare();
		}

		if (document.querySelector('.nojs-lb')) {
			fifthwallForm();
		}
		if (document.querySelector('.locations')) {
			locationsTabs();
		}

		if (document.querySelector('.olivier-awards')){
			olivierImagetoggle();

		}

	});

	window.addEventListener('load', () => {
		mobileCarousel();
		carousels();
	});

	// Tolerance (px) is the size a viewport can chance
	// before updating css variables this prevents jerky
	// resizing when browser chrome disappears on mobile
	const tolerance = 60;

	let vh = window.innerHeight * 0.01;
	document.documentElement.style.setProperty('--vh', `${ vh }px`);
	let lastHeight = window.innerHeight;

	let vw = window.innerWidth * 0.01;
	document.documentElement.style.setProperty('--vw', `${ vw }px`);
	let lastWidth = window.innerWidth;

	const headerHeight = document.querySelector('.site-header').offsetHeight;
	if (document.querySelector('.site-breadcrumbs')) {
		const breadcrumbHeight = document.querySelector('.site-breadcrumbs').offsetHeight;
		document.documentElement.style.setProperty('--breadcrumb-height', `${ breadcrumbHeight }px`);
	} else {
		const breadcrumbHeight = 0;
	}
	document.documentElement.style.setProperty('--header-height', `${ headerHeight }px`);

	const resizeVars = () => {
		if (Math.abs(lastHeight - window.innerHeight) > tolerance) {
			vh = window.innerHeight * 0.01;
			document.documentElement.style.setProperty('--vh', `${ vh }px`);
			lastHeight = window.innerHeight;
		}

		if (lastWidth !== window.innerWidth) {
			vw = window.innerWidth * 0.01;
			document.documentElement.style.setProperty('--vw', `${ vw }px`);
			lastWidth = window.innerWidth;
		}
	};
	window.addEventListener('resize', () => {
		resizeVars();
	});
	setTimeout(function() {
		resizeVars();
	}, 100);
})(document, window, history);
